import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Forward refs so consumers like react-router's <Link> (which forwards a ref
 * to its single child) and other ref-passing parents don't trigger
 * "Function components cannot be given refs" warnings.
 */
const Skeleton = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
);
Skeleton.displayName = "Skeleton";

export { Skeleton };
